<app-enfaf-modal
  heightButton="41px"
  [title]="eventData ? 'Editar Evento' : 'Nuevo Evento'"
  svgIcon="modal-calendar"
  (onClose)="handleCancel()"
  (onConfirm)="handleSave()"
  [disableConfirmButton]="confirmButtonDisabled"
  [isLoading]="isSavingEvent"
>
  @if (isLoadingEvent) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  } @else {
    <form [formGroup]="eventForm" class="events-form">
      <!-- Contenido Section -->
      <app-enfaf-expansion-panel-light title="Contenido" [isExpanded]="true">
        <div class="events-content">
          <div class="events-content-left">
            <app-enfaf-img-dragger
              [urlImage]="eventForm.value.eventImageUrl ?? ''"
              (onImageUpload)="uploadImage($event)"
              (onImageDelete)="deleteImage()"
              title="Imagen del evento"
              minHeight="100%"
            >
            </app-enfaf-img-dragger>
          </div>
          <div class="events-content-right">
            <!-- Title -->
            <enfaf-input
              label="Título del evento"
              placeholder="Título del evento"
              [control]="eventForm.get('title')!"
              name="title"
              autocomplete="off"
              [errorLabel]="titleErrors || ''"
              color="light"
            ></enfaf-input>

            <!-- Subtitle -->
            <enfaf-input
              label="Subtítulo del evento"
              placeholder="Subtítulo del evento"
              [control]="eventForm.get('subtitle')!"
              name="subtitle"
              autocomplete="off"
              [errorLabel]="subtitleErrors || ''"
              color="light"
            ></enfaf-input>
          </div>
        </div>
      </app-enfaf-expansion-panel-light>

      <!-- Gestión del evento Section -->
      <app-enfaf-expansion-panel-light title="Gestión del evento" [isExpanded]="true">
        <div class="event-management-form">
          <!-- Event Management Component -->
          <app-event-management #eventManagement [segmentationControl]="segmentationTypeControl" [segmentationTypeOptions]="segmentationTypeOptions">
          </app-event-management>

          <div class="dates-form">
            <!-- Start Date -->
            <enfaf-datetime-picker-dark 
              label="Fecha de inicio" 
              placeholder="Fecha de inicio" 
              name="startDate" 
              [control]="startDateControl"
              [errorLabel]="startDateErrors || ''"
            ></enfaf-datetime-picker-dark>

            <!-- End Date -->
            <enfaf-datetime-picker-dark 
              label="Fecha de fin" 
              placeholder="Fecha de fin" 
              name="endDate" 
              [control]="endDateControl"
              [errorLabel]="endDateErrors || ''"
            ></enfaf-datetime-picker-dark>
          </div>
        </div>
      </app-enfaf-expansion-panel-light>

      <!-- Avanzado Section -->
      <app-enfaf-expansion-panel-light title="Avanzado (Opcional)" [isExpanded]="true">
        <div class="event-advanced-form" formGroupName="advanced">
          <div class="advanced-row">
            <!-- Recurrence -->
            <enfaf-select-light
              label="Recurrencia"
              [control]="eventForm.get('advanced.recurrence')!"
              [options]="recurrenceOptions"
              hint="Esta opción creará un enlace único"
            ></enfaf-select-light>

            <!-- Platform -->
            <enfaf-select-light label="Plataforma" [control]="eventForm.get('advanced.platform')!" [options]="platformOptions"></enfaf-select-light>
          </div>

          <div class="advanced-row">
            <!-- Button Link -->
            @if (isPlatformCustom) {
              <enfaf-input
                label="Enlace del botón"
                placeholder="Enlace del botón"
                [control]="eventForm.get('advanced.buttonLink')!"
                name="buttonLink"
                autocomplete="off"
                [errorLabel]="buttonLinkErrors || ''"
                color="light"
              ></enfaf-input>
            }

            <!-- Button Text -->
            <enfaf-input
              label="Texto del botón"
              placeholder="Texto del botón"
              [control]="eventForm.get('advanced.buttonText')!"
              name="buttonText"
              autocomplete="off"
              [errorLabel]="buttonTextErrors || ''"
              color="light"
            ></enfaf-input>
          </div>

          <!-- Google Calendar Integration -->
          @if (isPlatformGoogleMeet) {
            <app-google-oauth #googleOauth></app-google-oauth>
          }
        </div>
      </app-enfaf-expansion-panel-light>
    </form>
  }
</app-enfaf-modal>
